import React, { useEffect } from "react";
import { LinearProgress, Paper, Skeleton, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import {
  loadWorkshop,
  selectFilteredWorkshops,
  unselectWorkshop,
} from "../../state/workshopSlice";
import ListCard from "./ListCard/ListCard";
import { Box } from "@mui/system";
import { useNavigate, useParams } from "react-router-dom";
import noResultsImage from "../../images/no-results-image.png";

const WorkshopList = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const status = useSelector((state) => state.workshops.status);
  const workshops = useSelector(selectFilteredWorkshops);

  //get the workshop id from the url and load the workshop
  useEffect(() => {
    if (id) dispatch(loadWorkshop(id));
    else dispatch(unselectWorkshop());
  }, [id]);

  const selectWorkshop = (id) => {
    navigate(`/${id}`);
  };

  return (
    <>
      <Box sx={{ height: "100%", overflowY: "auto" }}>
        {status.listLoading && (
          <>
            <LinearProgress />
            <br />
            <Typography variant="h5">
              <Skeleton width="90%" animation="wave" />
            </Typography>
            <Typography variant="body2">
              <Skeleton width="75%" animation="wave" />
              <Skeleton width="75%" animation="wave" />
            </Typography>
          </>
        )}
        {workshops.map((workshop, index) => (
          <ListCard workshop={workshop} key={index} select={selectWorkshop} />
        ))}

        {
          //no workshops found
          !status.listLoading && workshops.length === 0 && (
            <Box
              style={{
                marginTop: "2rem",
                textAlign: "center",
                width: "100%",
                height: "160px",
              }}
            >
              <Box
                style={{
                  backgroundImage: `url(${noResultsImage})`,
                  backgroundSize: "contain",
                  backgroundRepeat: "no-repeat",
                  backgroundPositionX: "center",
                  width: "100%",
                  height: "100%",
                }}
              ></Box>
              <Typography variant="h5" color="gray">
                No workshops found
              </Typography>
              <Typography variant="body2" color="gray">
                Try changing your filter criteria
              </Typography>
            </Box>
          )
        }
      </Box>
    </>
  );
};

export default WorkshopList;
